import { Container } from '@mui/material';
import _ from 'lodash';

import { BackToTop } from '@common/components/BackToTop';
import * as campaignTab from '@campaign/domain/middlewares/campaignTab';
import * as user from '@campaign/domain/middlewares/user';
import { store } from '@campaign/domain/store';
import { useStoreState } from '@campaign/domain/store/useStoreState';
import { CustomerCampaignSection } from '@campaign/view/components/CustomerCampaignSection';

export function CampaignList() {
  const globalState = useStoreState();
  const onChangeCampaignListPage = _.partial(
    user.onChangeCampaignListPage,
    store
  );
  const onChangeUserCampaignListPage = _.partial(
    user.onChangeUserCampaignListPage,
    store
  );
  const onSelectedCampaignTabChange = _.partial(
    campaignTab.onChangeCampaignTab,
    store
  );

  return (
    <Container
      sx={(theme) => ({
        paddingBottom: '80px',
        paddingTop: '120px',
        [theme.breakpoints.down('md')]: {
          paddingBottom: '60px',
          paddingLeft: '15px',
          paddingRight: '15px',
          paddingTop: '60px',
        },
        [theme.breakpoints.up('md')]: {
          paddingLeft: '30px',
          paddingRight: '30px',
        },
      })}
    >
      <CustomerCampaignSection
        userIsLoggedIn={globalState.loggedInUser.isLogged}
        selectedCampaignTab={globalState.selectedCampaignTab}
        onSelectedCampaignTabChange={onSelectedCampaignTabChange}
        campaignList={globalState.campaignList}
        userCampaignList={globalState.userCampaignList}
        campaignListPagination={globalState.pagination.campaignList}
        userCampaignListPagination={globalState.pagination.userCampaignList}
        onChangeCampaignListPage={onChangeCampaignListPage}
        onChangeUserCampaignListPage={onChangeUserCampaignListPage}
        isCampaignListPaginationLoading={globalState.loading.campaignList}
        isUserCampaignListPaginationLoading={
          globalState.loading.userCampaignList
        }
        campaignListError={globalState.errors.campaignList}
        userCampaignListError={globalState.errors.userCampaignList}
      />
      <BackToTop />
    </Container>
  );
}
